import Vue from 'vue'
import VueRouter from 'vue-router'
import InformationPage from '../vue/pages/Information.vue'

export default {
	init() {
		Vue.use(VueRouter)
		const routes = [
			// { path: '/', redirect: '/all' },
			{ path: '/', name: 'index', component: InformationPage },
			// { path: '/:slug', name: 'cat', component: InformationPage },
		]
		const router = new VueRouter({
			mode: 'history',
			routes,
			base: '/information',
		})
		new Vue({
			el: '.main-content',
			router,
		})
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}
